import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../config/apiconfig';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [userType, setUserType] = useState('employee');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(false);

    try {
      setSubmitting(true);
      await axios.post(`${API_BASE_URL}/api/password-reset/request`, {
        email,
        userType,
      });
      setSuccess(true);
    } catch (err) {
      setError(err?.response?.data?.error || 'Failed to request password reset');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen p-6 bg-gradient-to-r from-blue-900 to-blue-700 flex items-center justify-center">
      <div className="w-full max-w-md bg-white p-6 rounded-xl shadow-lg">
        <h1 className="text-2xl font-bold mb-4">Forgot Password</h1>

        {error && (
          <div className="bg-red-50 border border-red-200 text-red-600 p-3 rounded-lg mb-4">
            {error}
          </div>
        )}

        {success && (
          <div className="bg-green-50 border border-green-200 text-green-700 p-3 rounded-lg mb-4">
            If the email exists, a password reset link has been sent.
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-sm mb-1">Account type</label>
            <select
              className="border rounded w-full p-3"
              value={userType}
              onChange={(e) => setUserType(e.target.value)}
            >
              <option value="employee">Employee</option>
              <option value="user">Recruiter</option>
            </select>
          </div>

          <div className="mb-4">
            <label className="block text-sm mb-1">Email address</label>
            <input
              type="email"
              className="border rounded w-full p-3"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
            />
          </div>

          <button
            type="submit"
            disabled={submitting || !email}
            className={`w-full py-3 rounded text-white ${submitting || !email ? 'bg-gray-400' : 'bg-blue-600 hover:bg-blue-700'}`}
          >
            {submitting ? 'Sending...' : 'Send reset link'}
          </button>
        </form>

        <button
          type="button"
          onClick={() => navigate('/')}
          className="mt-4 w-full py-3 rounded border border-gray-300 hover:bg-gray-50"
        >
          Back to login
        </button>
      </div>
    </div>
  );
}
